const _excluded = ["field", "form", "meta"],
  _excluded2 = ["errorMessage"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { getErrorMessage } from '../formikControlsUtils';
import { MaskedTextField } from 'office-ui-fabric-react';
import { jsx as _jsx } from "react/jsx-runtime";
export function mapFieldToMaskedTextField(_ref) {
  let {
    form,
    field,
    meta
  } = _ref;
  return _objectSpread(_objectSpread({}, field), {}, {
    errorMessage: getErrorMessage({
      form,
      field,
      meta
    }),
    onChange: (_, value) => {
      form.setFieldValue(field.name, value);
    }
  });
}
export function FormikMaskedTextField(_ref2) {
  let {
      field,
      form,
      meta
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  const _mapFieldToMaskedText = mapFieldToMaskedTextField({
      field,
      form,
      meta
    }),
    {
      errorMessage
    } = _mapFieldToMaskedText,
    fieldProps = _objectWithoutProperties(_mapFieldToMaskedText, _excluded2);
  return /*#__PURE__*/_jsx(MaskedTextField, _objectSpread(_objectSpread({
    errorMessage: errorMessage // allow for prop overwrite
  }, props), fieldProps));
}